"use client";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import Logo from "./Logo";
import { useEffect, useState } from "react";
import { useAuthMinimal } from "@/hooks/useAuthMinimal";


export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  const { user, loading } = useAuthMinimal();
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };


    // do initial check
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={`sticky inset-x-0 top-0 z-50 transition-all duration-300 ease-in-out bg-background/[0.65] ${
        isScrolled ? 'backdrop-blur-[100px]' : ''
      }`}>
      <nav className="mx-auto flex h-full w-full max-w-(--breakpoint-xl) items-center px-6 min-h-[52px]">
        <div className="flex items-center lg:flex-1">
          <Link
            href="/"
            className="flex-shrink-0 text-foreground hover:text-foreground/80 transition-colors"
          >
            <Logo className="h-7 w-auto" variant="light" />
          </Link>
        </div>
        <div className="hidden items-center justify-center gap-14 font-semibold text-sm leading-6 lg:flex text-foreground">
          <Link
            href="/#features"
            className="text-sm text-foreground/70 hover:text-foreground transition-colors font-medium"
          >
            Features
          </Link>
          <Link
            href="/#how-it-works"
            className="text-sm text-foreground/70 hover:text-foreground transition-colors font-medium"
          >
            How it works
          </Link>
          <Link
            href="/pricing"
            className="text-sm text-foreground/70 hover:text-foreground transition-colors font-medium"
          >
            Pricing
          </Link>
          <Link href="/connect" className="text-sm text-foreground/70 hover:text-foreground font-medium">ChatGPT / Claude</Link>
        </div>
        <div className="flex-1 items-center justify-end flex">
          {!loading && (
            <div className="fade-in animate-in transition-opacity duration-300">
              {user ? (
                // Show dashboard link for authenticated users
                <Button size="sm" asChild variant="ghost" className="text-foreground/70 hover:text-foreground hover:bg-transparent">
                  <Link href="/dashboard">Dashboard</Link>
                </Button>
              ) : (
                // Show sign in and try for free for unauthenticated users
                <>
                  <Button
                    variant="ghost"
                    size="sm"
                    asChild
                    className="text-foreground/70 hover:text-foreground hover:bg-transparent"
                  >
                    <Link href="/signin">Sign In</Link>
                  </Button>
                  <Button size="sm" asChild className="hidden sm:inline-flex">
                    <Link href="/signup?redirect=/dashboard">Add to Chrome</Link>
                  </Button>
                </>
              )}
            </div>
          )}
        </div>
      </nav>
      <div className="relative w-full">
        <div className={`absolute inset-x-0 bottom-0 h-px w-full origin-center transform-gpu transition-transform duration-200 ease-out bg-border ${
          isScrolled ? 'scale-x-100' : 'scale-x-0'
        }`}></div>
      </div>
    </header>
    </>
  );
}
